import React from "react";
import { Link } from "react-router-dom";
import RawHeader from "../components/RawHeader";
import { InfoFooter } from "./InfoPages";
import { startCustomerLogin } from "../lib/customerApi";
import { useCustomer } from "../contexts/CustomerContext";
import { Navigate } from "react-router-dom";

const CustomerLogin = () => {
  const { customer, loading } = useCustomer();
  if (loading) return null;
  if (customer) return <Navigate to="/account" replace />;

  return (
    <div data-testid="login-page" className="min-h-screen text-white">
      <RawHeader variant="public" />
      <section className="max-w-md mx-auto px-6 py-20">
        <div className="raw-panel p-10 text-center">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#d4af37] mb-3">// CUSTOMER ACCESS</div>
          <h1 className="font-display text-3xl text-[#d4af37] mb-4">Sign In</h1>
          <p className="text-zinc-400 text-sm mb-8 leading-relaxed">
            Save your favourite pieces, see your order history and track shipments.
          </p>
          <button
            data-testid="google-login-btn"
            onClick={startCustomerLogin}
            className="w-full flex items-center justify-center gap-3 bg-white text-black font-bold tracking-[0.15em] text-sm uppercase py-3 hover:bg-zinc-200 transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.5 29.3 4.5 24 4.5 12.7 4.5 3.5 13.7 3.5 25S12.7 45.5 24 45.5 44.5 36.3 44.5 25c0-1.5-.2-3-.9-4.5z"/>
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.5 29.3 4.5 24 4.5 16.2 4.5 9.5 9 6.3 14.7z"/>
              <path fill="#4CAF50" d="M24 45.5c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.6 2.4-7.2 2.4-5.2 0-9.7-3.3-11.3-8l-6.5 5C9.5 41 16.2 45.5 24 45.5z"/>
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.1 4.1-3.9 5.5l6.2 5.2C41.7 35 44.5 30 44.5 25c0-1.5-.2-3-.9-4.5z"/>
            </svg>
            Sign in with Google
          </button>
          <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-600 mt-6">
            <Link to="/" className="hover:text-[#d4af37]">← Back to shop</Link>
          </p>
        </div>
      </section>
      <InfoFooter />
    </div>
  );
};

export default CustomerLogin;
